import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { IncidentsGridWebComponentSchema } from '../types';

export class IncidentsGridBaseDataProvider extends BaseWebComponentDataProvider {
  async getDataForView(): Promise<IncidentsGridWebComponentSchema> {
    throw new Error('Not implemented');
  }
}
